import { render, staticRenderFns } from "./Paste.vue?vue&type=template&id=f7660590&scoped=true&"
import script from "./Paste.vue?vue&type=script&lang=js&"
export * from "./Paste.vue?vue&type=script&lang=js&"
import style0 from "./Paste.vue?vue&type=style&index=0&id=f7660590&lang=scss&scoped=true&"
import style1 from "./Paste.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7660590",
  null
  
)

export default component.exports